export default "__VITE_ASSET__CB9zFEMW__"